import React from 'react'
import { useStaticQuery, graphql } from 'gatsby'
import { GatsbyImage, getImage } from "gatsby-plugin-image"

const LandingBg = () => {
  const data = useStaticQuery(graphql`
    query LandingBgQuery {
      imgMtnBg: file(relativePath: { eq: "bg/bg-mountain-comp-1.jpg" }) {
        childImageSharp {
          gatsbyImageData(
            width: 1920
            placeholder: TRACED_SVG
          )
        }
      }
    }
  `)

  const imgMtnBg = getImage(data.imgMtnBg)

  return (
    <div className="h-screen">
      <GatsbyImage image={imgMtnBg} alt="" className="h-screen" />
    </div>
  )
}

export default LandingBg